import Presentation from "./presentation";

const LiveStreamCards = ( {
	data,
	fetchMore,
	isDepleted,
	cardType,
	isLoading
} ) => {

	return (
		<Presentation
			cardType   = { cardType }
			data       = { data }
			fetchMore  = { fetchMore }
			isDepleted = { isDepleted }
			isLoading  = { isLoading }
		/>
	);
};

export default LiveStreamCards;